// const dstaUrl = "http://localhost:4545";
const dstaUrl = "https://dstastag.x0pa.ai";
const baseDomain = `${window.location.protocol}//${window.location.host}`;
const baseUrl = `${baseDomain}/roboroy/api/v1`;

export { baseUrl,dstaUrl };
